/**
 * @generated SignedSource<<0bbd7f1d321675d7a054472e3da20da2>>
 * @relayHash 4964ea634c66d36e7cdb00729c9046f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c71b4a59715945ffd277dace955a71d3b0570d90f2c4b3b15614672eb3600644

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c71b4a59715945ffd277dace955a71d3b0570d90f2c4b3b15614672eb3600644",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
